import { render, staticRenderFns } from "./FeatureCarousel.vue?vue&type=template&id=cf020666&"
import script from "./FeatureCarousel.vue?vue&type=script&lang=js&"
export * from "./FeatureCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCarousel.vue?vue&type=style&index=0&id=cf020666&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports